import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('div.tb-connection-details', {
    paddingBottom: '18px',
    whiteSpace: 'nowrap',
});

cssRule('div.tb-connection-details .tb-connection-details-row', {
    display: 'table-row',
});

cssRule('div.tb-connection-details .tb-connection-details-label', {
    display: 'table-cell',
});

cssRule('div.tb-connection-details .tb-connection-details-value', {
    display: 'table-cell',
    paddingLeft: '18px',
});

cssRule('.tb-connection-details-label', {
    fontWeight: 'bold',
});

cssRule('.tb-connection-credentials-username', {
    paddingBottom: '12px',
    width: '100%',
});

cssRule('.tb-connection-credentials-password', {
    paddingBottom: '18px',
    width: '100%',
});

cssRule('.tb-o-auth-sign-in', {
    marginTop: '12px',
    textAlign: 'center',
});

cssRule('.tb-embedded-auth-advisory', {
    textAlign: 'left',
    margin: '18px auto',
    padding: '3px 18px',
    border: '1px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.default, '#333'),
    maxWidth: '70%',
});

